import script from "./CountdownCircle.vue?vue&type=script&setup=true&lang=js"
export * from "./CountdownCircle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__